import { getApiBase } from '../widget-api/config';

/**
 * Приводит сохранённые медиа-ссылки к URL для `<img>`.
 * Новые загрузки обычно хранят полный URL, но старые/ручные значения могли попасть как `/media/...` или S3-key `uploads/...`.
 */
export function displayableMediaUrl(raw: string | null | undefined, apiBase = getApiBase()): string | null {
  if (raw == null) return null;
  const s = raw.trim();
  if (!s) return null;
  if (s.includes('images.example.test')) return null;
  if (s.startsWith('http://') || s.startsWith('https://')) return s;
  if (s.startsWith('//') && s.length > 2) {
    return `${window.location.protocol}${s}`;
  }
  const mediaPath = mediaObjectPath(s);
  if (mediaPath) {
    const apiOrigin = apiBaseOrigin(apiBase);
    return apiOrigin ? `${apiOrigin}${mediaPath}` : mediaPath;
  }
  if (s.startsWith('/')) return s;
  return null;
}

/** Пригоден для атрибута src у <img> / превью. */
export function isDisplayableMediaUrl(raw: string | null | undefined): boolean {
  return displayableMediaUrl(raw) != null;
}

function mediaObjectPath(value: string): string | null {
  if (value.startsWith('/media/')) return value;
  if (value.startsWith('media/')) return `/${value}`;
  if (value.startsWith('/uploads/')) return `/media${value}`;
  if (value.startsWith('uploads/')) return `/media/${value}`;
  return null;
}

function apiBaseOrigin(base: string): string | null {
  if (!base) return null;
  try {
    const fallbackOrigin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
    return new URL(base, fallbackOrigin).origin;
  } catch {
    return null;
  }
}
